import apiClient from '../axios.js';

/**
 * 電商平台整合 API
 */
export const ecomService = {
  /**
   * 查詢電商平台列表
   * @returns {Promise<Object>} 平台列表
   */
  listPlatforms: async () => {
    const response = await apiClient.get('/ecom/platforms');
    return response;
  },

  /**
   * 查詢電商平台設定（使用配置 ID）
   * @param {string} configId - 配置 ID
   * @returns {Promise<Object>} 平台設定
   */
  getPlatformConfig: async (configId) => {
    const response = await apiClient.get(`/ecom/configs/${configId}`);
    return response;
  },

  /**
   * 設定電商平台配置
   * @param {string} platform - 平台代碼
   * @param {Object} config - 配置資料
   * @returns {Promise<Object>} 設定結果
   */
  setPlatformConfig: async (platform, config) => {
    const response = await apiClient.post(`/ecom/platforms/${platform}/config`, config);
    return response;
  },

  /**
   * 查詢未綁定訂單
   * @param {Object} params - 查詢參數
   * @returns {Promise<Object>} 未綁定訂單列表
   */
  listUnboundOrders: async (params = {}) => {
    const response = await apiClient.get('/ecom/unbound-orders', { params });
    return response;
  },

  /**
   * 綁定會員到電商訂單
   * @param {string} orderId - 訂單 ID
   * @param {string} memberId - 會員 ID
   * @returns {Promise<Object>} 綁定結果
   */
  bindMemberToOrder: async (orderId, memberId) => {
    const response = await apiClient.post('/ecom/unbound-orders/bind', {
      orderId,
      memberId
    });
    return response;
  },

  /**
   * 查詢同步狀態
   * @param {Object} params - 查詢參數
   * @returns {Promise<Object>} 同步狀態
   */
  getSyncStatus: async (params = {}) => {
    const response = await apiClient.get('/ecom/sync-status', { params });
    return response;
  },

  /**
   * 刪除電商平台配置
   * @param {string} configId - 配置 ID
   * @returns {Promise<Object>} 刪除結果
   */
  deletePlatformConfig: async (configId) => {
    const response = await apiClient.delete(`/ecom/configs/${configId}`);
    return response;
  },

  /**
   * 手動觸發 API 輪詢（適用於 api_polling 連線方式）
   * @param {string} platform - 平台代碼
   * @param {string|null} configId - 指定配置 ID（可選）
   * @returns {Promise<Object>} 輪詢結果
   */
  pollPlatformOrders: async (platform, configId = null) => {
    const body = configId ? { configId } : {};
    const response = await apiClient.post(`/ecom/platforms/${platform}/poll`, body);
    return response;
  }
};
